import { useEffect, useRef, useState } from "react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { MessageCircle, Send, X, Loader2, GraduationCap } from "lucide-react";

export function AskMentor() {
  const [open, setOpen] = useState(false);
  const [msgs, setMsgs] = useState([]);
  const [text, setText] = useState("");
  const [busy, setBusy] = useState(false);
  const scrollRef = useRef(null);

  const load = async () => {
    try { const { data } = await api.get("/mentor/chat"); setMsgs(data.messages || []); } catch { /* ignore */ }
  };
  useEffect(() => {
    if (!open) return;
    load();
    const t = setInterval(load, 6000);
    return () => clearInterval(t);
  }, [open]);
  useEffect(() => { scrollRef.current?.scrollTo(0, scrollRef.current.scrollHeight); }, [msgs]);

  const send = async () => {
    if (!text.trim()) return;
    setBusy(true);
    try { await api.post("/mentor/request", { text: text.trim() }); setText(""); await load(); }
    catch { /* ignore */ }
    finally { setBusy(false); }
  };

  return (
    <>
      <Button onClick={() => setOpen(true)} data-testid="ask-mentor-button"
        className="w-full h-11 rounded-xl font-semibold text-black hover:opacity-90" style={{ backgroundColor: "var(--sfx-accent)" }}>
        <GraduationCap className="mr-2 h-4 w-4" /> Mande yon Mentor
      </Button>

      {open && (
        <div className="fixed inset-0 z-50 flex items-end sm:items-center justify-center bg-black/60 p-0 sm:p-4" data-testid="ask-mentor-modal">
          <div className="w-full sm:max-w-md bg-[#0A1120] border border-[#14233d] rounded-t-3xl sm:rounded-3xl flex flex-col h-[70vh] sm:h-[520px]">
            <div className="flex items-center justify-between px-5 py-3.5 border-b border-[#14233d]">
              <div className="flex items-center gap-2">
                <GraduationCap className="h-4 w-4" style={{ color: "var(--sfx-accent)" }} />
                <span className="font-heading font-semibold text-sm">Mentor Team</span>
              </div>
              <button onClick={() => setOpen(false)} data-testid="ask-mentor-close" className="text-[#5f7ba6] hover:text-white"><X className="h-5 w-5" /></button>
            </div>
            <div ref={scrollRef} className="flex-1 overflow-y-auto px-4 py-4 space-y-3">
              {msgs.length === 0 ? (
                <div className="text-center text-[#5f7ba6] text-sm mt-10 px-6">
                  <MessageCircle className="h-8 w-8 mx-auto mb-2 opacity-50" />
                  Poze yon kesyon sou chart la — yon mentor ap reponn ou dirèkteman.
                </div>
              ) : msgs.map((m) => (
                <div key={m.id} className={`flex ${m.from === "client" ? "justify-end" : "justify-start"}`}>
                  <div className={`max-w-[78%] rounded-2xl px-3.5 py-2 ${m.from === "client" ? "text-black" : "bg-[#12203a] text-[#eee]"}`}
                    style={m.from === "client" ? { backgroundColor: "var(--sfx-accent)" } : {}}>
                    {m.from === "mentor" && <div className="text-[10px] font-mono-term uppercase opacity-70 mb-0.5">{m.name || "Mentor"}</div>}
                    <div className="text-sm whitespace-pre-wrap">{m.text}</div>
                  </div>
                </div>
              ))}
            </div>
            <div className="border-t border-[#14233d] p-3 flex items-center gap-2">
              <Input value={text} onChange={(e) => setText(e.target.value)} onKeyDown={(e) => e.key === "Enter" && send()}
                data-testid="ask-mentor-input" placeholder="Ekri kesyon w..." className="bg-[#060c18] border-[#14233d] rounded-xl h-11" />
              <Button onClick={send} disabled={busy} data-testid="ask-mentor-send"
                className="h-11 rounded-xl px-4 text-black hover:opacity-90" style={{ backgroundColor: "var(--sfx-accent)" }}>
                {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Send className="h-4 w-4" />}
              </Button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
